/**
 * Legacy org-less plugin page: redirects to `/$org/connections/$pluginId`
 * for the last-picked org, keeping the plugin.
 */
import { createFileRoute, redirect } from "@tanstack/react-router";

import { orgUrlSegment } from "../orgRouting";
import { readLastPickedOrgId } from "../state/orgs";

export const Route = createFileRoute("/connections_/$pluginId")({
  beforeLoad: async ({ context, params }) => {
    if (
      context.authGateState.status !== "authenticated" &&
      context.authGateState.status !== "hosted-static"
    ) {
      throw redirect({ to: "/pair", replace: true });
    }
    const lastPickedOrgId = readLastPickedOrgId();
    if (!lastPickedOrgId) {
      throw redirect({ to: "/", replace: true });
    }
    throw redirect({
      to: "/$org/connections/$pluginId",
      params: { org: orgUrlSegment(lastPickedOrgId), pluginId: params.pluginId },
      replace: true,
    });
  },
});
